<template>
    <div class="relative w-screen h-screen overflow-hidden flex">
        <slot />
    </div>
</template>
